import { render, staticRenderFns } from "./ManagerCategoryEdit.vue?vue&type=template&id=019ee95e"
import script from "./ManagerCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ManagerCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports